module.exports = __webpack_public_path__ + "static/media/memo_edit.70a90715.svg";